import { base, getEnv } from '../../utils';

export const getFollowerPagination = async (pagination, sort) => {
  try {
    const limit = pagination.limit;
    const current = pagination.current;
    const userId = pagination.userId;
    const { SITE_TYPE } = getEnv();

    const url = `/v1/${SITE_TYPE}/users/${userId}/followers_paging?limit=${limit}&page=${current}&sort=${sort}&user_id=${userId}`;

    const response = await base.get(url);

    const result = {
      pages: response.data.pages,
      totalCount: Number(response.headers['x-total-count']),
      totalPages: Number(response.headers['x-total-pages']),
      current,
    };

    return result;
  } catch (error) {
    throw new Error(error);
  }
};
